export enum QueryKeys {
    USER_DETAILS = 'USER_DETAILS',
    NEARBY_LOCATIONS = 'NEARBY_LOCATIONS',
    PAYROLL_LOCATION = 'PAYROLL_LOCATION',
    PAYROLL_LOCATION_WEEKLY = 'PAYROLL_LOCATION_WEEKLY',
    PAYROLL_LOCATION_DAILY = 'PAYROLL_LOCATION_DAILY',
    PAYROLL_WORKGROUP = 'PAYROLL_WORKGROUP',
    PAYROLL_WORKGROUP_DRILL = 'PAYROLL_WORKGROUP_DRILL',
    PAYROLL_OVERTIME = 'PAYROLL_OVERTIME',
    SHORTAGE = 'SHORTAGE',
    SHORTAGE_TOP_TEN = 'SHORTAGE_TOP_TEN',
    SHORTAGE_MERCH = 'SHORTAGE_MERCH',
    SAFETY_LAGGING = 'SAFETY_LAGGING',
    SAFETY_LEADING = 'SAFETY_LEADING',
    SAFETY_TOTAL = 'SAFETY_TOTAL',
    SAFETY_STORE_LAGGING = 'SAFETY_STORE_LAGGING',
    SAFETY_STORE_TOTAL = 'SAFETY_STORE_TOTAL',
    SAFETY_STORE_LEADING = 'SAFETY_STORE_LEADING',
    LOCATION_HIERARCHY = 'LOCATION_HIERARCHY',
    SALES_AREA_OF_STORE = 'SALES_AREA_OF_STORE',
    SALES_OVERVIEW = 'SALES_OVERVIEW',
    SALES_HOURLY = 'SALES_HOURLY',
    SALES_LOCATION = 'SALES_LOCATION',
    SALES_LOCATION_HISTORICAL = 'SALES_LOCATION_HISTORICAL',
    ASSETS_PROTECTION_SECURE_RGD = 'ASSETS_PROTECTION_SECURE_RGD',
    STORE_FACTS = 'STORE_FACTS',
    STORE_LEADERSHIP = 'STORE_LEADERSHIP',
    USER_CONTEXT = 'USER_CONTEXT',
    USER_CONTEXT_CREATE = 'USER_CONTEXT_CREATE',
    USER_CONTEXT_UPDATE = 'USER_CONTEXT_UPDATE',
    ASSETS_PROTECTION_STORE = 'ASSETS_PROTECTION_STORE',
    ASSETS_PROTECTION_SECURE = 'ASSETS_PROTECTION_SECURE',
    ASSETS_PROTECTION_THEFT_STORE = 'ASSETS_PROTECTION_THEFT_STORE',
    MERCHANDISE = 'MERCHANDISE',
    NOTES = 'NOTES',
    ITEM_DETAILS = 'ITEM_DETAILS',
    TARGET_CIRCLE = 'TARGET_CIRCLE',
    TARGET_CIRCLE_360 = 'TARGET_CIRCLE_360',
    TARGET_CIRCLE_CARD = 'TARGET_CIRCLE_CARD',
    LOYALTY_OVERVIEW = 'LOYALTY_OVERVIEW',
    STORE_TRAILERS = 'STORE_TRAILERS',
    TRAILER_SCHEDULE = 'TRAILER_SCHEDULE',
    TRAILER_RGD = 'TRAILER_RGD',
    TRAILER_ETA = 'TRAILER_ETA',
    STORE_TRAILER_DETAILS = 'STORE_TRAILER_DETAILS',
    OPERATIONS_RECALL = 'OPERATIONS_RECALL',
    OPERATIONS_DIMENSIONS = 'OPERATIONS_DIMENSIONS',
    THEFT_RGD_INTERNAL = 'THEFT_RGD_INTERNAL',
    THEFT_RGD_EXTERNAL = 'THEFT_RGD_EXTERNAL',
    THEFT_STORE_GF_INTERNAL = 'THEFT_STORE_GF_INTERNAL',
    THEFT_STORE_GF_EXTERNAL = 'THEFT_STORE_GF_EXTERNAL',
    PAYROLL_RGD = 'PAYROLL_RGD',
    BRANDS = 'BRANDS',
    BRANDSALES = 'BRANDSALES',
    BRANDS_TRENDS = 'BRANDSTRENDS',
    BRANDS_LOYALTY = 'BRANDS_LOYALTY',
    BRANDSGREENFIELD = 'BRANDSGREENFIELD',
    STORE_FULFILLMENT = 'STORE_FULFILLMENT',
    STORE_FULFILLMENT_PICKUP_HISTORICAL = 'STORE_FULFILLMENT_PICKUP_HISTORICAL',
    NDD_LOCATION_METRICS = 'NDD_LOCATION_METRICS',
    NDD_HIERARCHY_METRICS = 'NDD_HIERARCHY_METRICS',
    NDD_HISTORICAL_METRICS = 'NDD_HISTORICAL_METRICS',
    STORE_FULFILLMENT_SHIP_HISTORICAL = 'STORE_FULFILLMENT_SHIP_HISTORICAL',
    STORE_FULFILLMENT_SHIP_ON_TIME = 'STORE_FULFILLMENT_SHIP_ON_TIME',
    OPERATIONSMETRICSDETAILS = 'OPERATIONSMETRICSDIMENSIONS',
    FULFILLMENT_CAPABILITIES = 'FULFILLMENT_CAPABILITIES',
    FULFILLMENT_CAPABILITIES_RGD = 'FULFILLMENT_CAPABILITIES_RGD',
    BASKET_SALES_HISTORICAL = 'BASKET_SALES_HISTORICAL',
    INSIGHTS_DIRECTOR_SUMMARY = 'INSIGHTS_DIRECTOR_SUMMARY',
    INSIGHTS_DIRECTOR_AUDIO_SUMMARY = 'INSIGHTS_DIRECTOR_AUDIO_SUMMARY',
    INSIGHTS_DIRECTOR_AUDIO_TRANSCRIPT = 'INSIGHTS_DIRECTOR_AUDIO_TRANSCRIPT',
    MY_TARGET_PERFORMANCE_METRIC_INFO = 'MY_TARGET_PERFORMANCE_METRIC_INFO',
    MY_TARGET_PERFORMANCE_GUEST_METRICS = 'MY_TARGET_PERFORMANCE_GUEST_METRICS',
    MY_TARGET_PERFORMANCE_GUEST_GOALS = 'MY_TARGET_PERFORMANCE_GUEST_GOALS',
    MY_TARGET_PERFORMANCE_FINANCIAL_METRICS = 'MY_TARGET_PERFORMANCE_FINANCIAL_METRICS',
    MY_TARGET_PERFORMANCE_FINANCIAL_GOALS = 'MY_TARGET_PERFORMANCE_FINANCIAL_GOALS',
    MY_TARGET_PERFORMANCE_TEAM_METRICS = 'MY_TARGET_PERFORMANCE_TEAM_METRICS',
    MY_TARGET_PERFORMANCE_TEAM_GOALS = 'MY_TARGET_PERFORMANCE_TEAM_GOALS',
    MY_TARGET_PERFORMANCE_GREEN_STORES = 'MY_TARGET_PERFORMANCE_GREEN_STORES',
    MY_TARGET_PERFORMANCE_DETAILS = 'MY_TARGET_PERFORMANCE_DETAILS',
    MY_TARGET_PERFORMANCE_DETAIL_GREEN_STORES = 'MY_TARGET_PERFORMANCE_DETAIL_GREEN_STORES',
    MY_TARGET_PERFORMANCE_DETAIL_STORES = 'MY_TARGET_PERFORMANCE_DETAIL_STORES',
}
